import React from 'react';
import { Modal, StyleSheet, Text, TouchableOpacity, View, TextInput, Dimensions, KeyboardAvoidingView, TouchableWithoutFeedback, Platform } from 'react-native';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';
import { BlurView } from 'expo-blur';
import { Ionicons } from '@expo/vector-icons';

const MFAModal = (props) => {
  
  const inputRef = React.useRef();
  const windowWidth = Dimensions.get('window').width;

  React.useEffect(() => {
    props.setMFACode('');
  }, []);

  React.useEffect(() => {
    if(props.show){
      setTimeout(() => inputRef.current.focus(), 10);
    }
  }, [props.show])

  const viewStyle = () => {
    if(Platform.OS === 'web'){
      let width = 400;
      if(windowWidth < 420){
        width = windowWidth - 30;
      }
      return {
        width: width,
      }
    }
    return {
      width: '100%',
    };
  }

  if(Platform.OS === 'web' && !props.show){
    return null;
  }
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={props.show}
      style={Platform.OS === 'web' && CS.webModal}
    >
      <BlurView intensity={85} style={StyleSheet.absoluteFill} tint='dark'>
        <KeyboardAvoidingView
          behavior={Platform.OS == "ios" ? "padding" : "height"}
          style={{ flex: 1 }}
          // , backgroundColor: 'rgba(0,0,0,0.75)'
          // keyboardVerticalOffset={headerHeight}
        >
          {/* <TouchableWithoutFeedback onPress={Platform.OS === 'web' ? null : Keyboard.dismiss}> */}
            <View style={styles.container}>
              <View style={[styles.view, viewStyle()]}>
                <TouchableOpacity activeOpacity={0.6} onPress={() => props.cancel()} style={styles.cancel}>
                  <Ionicons name="ios-close-circle-outline" size={44} color={Colors.mediumGrey} />
                  <Ionicons name="ios-close-circle" size={42} color={Colors.yellow} style={{ position: 'absolute' }}/>
                </TouchableOpacity>
                <Text style={[CS.mediumText, CS.whiteText]}>Please enter the 6-digit code that has been sent to you via SMS or email.</Text>
                <View>
                  <TextInput
                    style={styles.input}
                    textContentType='oneTimeCode'
                    spellCheck={false}
                    autoCorrect={false}
                    onChangeText={(t) => props.setMFACode(t)}
                    maxLength={6}
                    // autoFocus={true}
                    keyboardType='number-pad'
                    returnKeyType='done'
                    inputmode='numeric'
                    autoCompleteType={Platform.OS === 'web' ? 'one-time-code' : 'off'}
                    value={props.MFACode}
                    ref={inputRef}
                  />
                  {props.showTrusted && 
                  <View style={[CS.rowContainer, styles.trustedContainer]}>
                    <TouchableOpacity activeOpacity={0.6} onPress={() => props.setMFATrusted(!props.MFATrusted)}>
                      <Ionicons name="ios-checkmark-circle" size={36} color={props.MFATrusted ? Colors.yellow : Colors.lightGrey} />
                    </TouchableOpacity>
                    <Text style={[CS.smallText, CS.lightText, { marginLeft: 10 }]}>{props.MFATrusted ? 'Trust this device' : 'Do not trust this device'}</Text>
                  </View>
                  }
                </View>
              </View>
            </View>
          {/* </TouchableWithoutFeedback> */}
        </KeyboardAvoidingView>
      </BlurView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    padding: 20,
    width: '100%',
  },
  view: {
    // flex: 1,
    // width: Platform.OS === 'web' ? 400 : '100%',
    justifyContent: 'center',
    alignSelf: 'center',
    // marginTop: 22,
    backgroundColor: Colors.mediumGrey,
    padding: 15,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  input: {
    borderWidth: 1,
    borderColor: Colors.lightBlue2,
    padding:10,
    // height: 80,
    borderRadius: 10,
    marginTop: 10,
    backgroundColor: Colors.textInputBackground,
    color: Colors.lightText,
    textAlign: 'center',
    fontSize: 80,
  },
  trustedContainer: {
    marginTop: 15,
  },
  cancel: {
    position: 'absolute',
    top: -15,
    right: -15,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default MFAModal;